import { Link as ChakraLink, type LinkProps } from '@react/chakra';
import NextLink, { type LinkProps as NextLinkProps } from 'next/link';

import type { JSX, ReactNode } from 'react';

export interface ILinkProps extends NextLinkProps {
  children?: ReactNode;
  noUnderline?: boolean;
  containerProps?: LinkProps;
}

export function Link({
  containerProps,
  noUnderline = false,
  ...rest
}: ILinkProps): JSX.Element {
  return (
    <ChakraLink
      asChild
      pos='relative'
      _focus={{
        outline: 'none',
      }}
      _hover={{
        color: 'white',
        _after: {
          transform: 'scaleX(1)',
        },
      }}
      {...containerProps}
      _after={
        noUnderline
          ? {}
          : {
              left: 0,
              content: '""',
              height: '2px',
              width: '100%',
              bottom: '-4px',
              pos: 'absolute',
              bgColor: 'white',
              display: 'block',
              transform: 'scaleX(0)',
              transformOrigin: 'left',
              transition: 'transform 0.25s ease',
              ...containerProps?._after,
            }
      }
    >
      <NextLink {...rest} />
    </ChakraLink>
  );
}
